export default __webpack_public_path__ + "static/btn-submit-aac04348a0955cc9fe5beb09dca8a12b.png";